import { RootState } from '@Store/index';
import {
  getPassportStatusesDictSelector,
  getPassportTypeDictSelector,
} from '@Store/selectors/dictionarySelector';
import { prepareRequisitionInfo } from '@Utils/requisitionInfo';
import { transformDictToOptions } from '@Utils/transformToOptions';
import { createSelector } from '@reduxjs/toolkit';

const passportRequest = (state: RootState) =>
  state.featureStores.passportRequest;

export const currentPassportRequest = createSelector(
  passportRequest,
  ({ passportRequest }) => passportRequest
);

export const passportRequestCreateRequisitionInfo = createSelector(
  [currentPassportRequest, getPassportStatusesDictSelector],
  (passportRequest, passportStatuses) => {
    const requisitionInfo = prepareRequisitionInfo(
      passportRequest,
      passportStatuses
    );
    return requisitionInfo;
  }
);

export const getPassportTypeOptions = createSelector(
  getPassportTypeDictSelector,
  (passportTypeDict) => {
    const output = transformDictToOptions(passportTypeDict);
    return output;
  }
);

export const purposeLabels = createSelector(
  getPassportTypeDictSelector,
  (passportTypes) => passportTypes.map((passportType) => passportType.codeDesc)
);

export const statusLabels = createSelector(
  getPassportStatusesDictSelector,
  (statuses) => statuses.map((status) => status.codeDesc)
);
